import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    selectAllAudiences,
    getAudienceStatus,
    fetchAudiencesAll,
    resetAudienceState,
} from 'features/audiences/audiencesSlice';
import { LoadingStatus } from 'GeminiViewerComponent/helpers/AsyncStatus';
import { AudienceTable } from './AudienceTable';
import { activateLoading, deactivateLoading } from 'GeminiViewerComponent/features/globals/loadingProgressSlice';

const AudienceManagementTab = () => {
    const dispatch = useDispatch();
    const ref = useRef(false);
    const audiences = useSelector(selectAllAudiences);
    const audienceStatus = useSelector(getAudienceStatus);
    const [sortBy, setSortBy] = useState('display_name');
    const [sortDirection, setSortDirection] = useState('ASC');
    const [audiencePayload, setAudiencePayload] = useState({
        sort: `${sortDirection === 'ASC' ? '' : '-'}${sortBy}`,
    });

    const getAudiencesData = async (payload) => {
        dispatch(activateLoading());
        await dispatch(fetchAudiencesAll({ ...payload }));
        dispatch(deactivateLoading());
    };

    useEffect(() => {
        if (ref.current === true) {
            getAudiencesData({ ...audiencePayload });
        }
        return () => {
            dispatch(resetAudienceState());
        };
    }, [audiencePayload]);

    useEffect(() => {
        if (audienceStatus === LoadingStatus.Idle) {
            getAudiencesData({
                ...audiencePayload,
            });
        }
        ref.current = true;
    }, [audienceStatus, dispatch]);

    const setSorting = (_sortBy, _sortDirection) => {
        setSortBy(_sortBy);
        setSortDirection(_sortDirection);
        setAudiencePayload({
            ...audiencePayload,
            sort: `${_sortDirection === 'ASC' ? '' : '-'}${_sortBy}`,
        });
    };

    return (
        <>
            <AudienceTable
                audiences={audiences}
                pageInfo={audiences}
                audiencePayload={audiencePayload}
                setAudiencePayload={setAudiencePayload}
                sortDirection={sortDirection}
                sortBy={sortBy}
                handleSort={(_sortBy, _sortDirection) => setSorting(_sortBy, _sortDirection)}
            />
        </>
    );
};

export { AudienceManagementTab };
